/**
 * Pop-up gallery overlay
 *
 * Opens a full-screen scrollable overlay ([data-popup-overlay] -> #id)
 * with close button, ESC support and body scroll lock. The trigger link
 * keeps its href as a no-JS fallback to the single pop-up page.
 */

function initPopupOverlay() {
	const triggers = document.querySelectorAll( '[data-popup-overlay]' );
	if ( ! triggers.length ) {
		return;
	}

	let openOverlay = null;
	let lastTrigger = null;

	function open( overlay, trigger ) {
		overlay.hidden = false;
		document.body.classList.add( 'popup-overlay-open' );
		openOverlay = overlay;
		lastTrigger = trigger;
		overlay.scrollTop = 0;
		const closeBtn = overlay.querySelector( '[data-popup-overlay-close]' );
		if ( closeBtn ) {
			closeBtn.focus();
		}
	}

	function close() {
		if ( ! openOverlay ) {
			return;
		}
		openOverlay.hidden = true;
		document.body.classList.remove( 'popup-overlay-open' );
		openOverlay = null;
		if ( lastTrigger ) {
			lastTrigger.focus();
			lastTrigger = null;
		}
	}

	triggers.forEach( function ( trigger ) {
		trigger.addEventListener( 'click', function ( e ) {
			const overlay = document.getElementById( trigger.getAttribute( 'data-popup-overlay' ) );
			if ( ! overlay ) {
				return; // fall through to the href
			}
			e.preventDefault();
			open( overlay, trigger );
		} );
	} );

	document.addEventListener( 'click', function ( e ) {
		if ( e.target.closest( '[data-popup-overlay-close]' ) ) {
			close();
		}
	} );

	document.addEventListener( 'keydown', function ( e ) {
		// Let Magnific Popup consume ESC first when the lightbox is open.
		if ( e.key === 'Escape' && openOverlay && ! document.querySelector( '.mfp-ready' ) ) {
			close();
		}
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initPopupOverlay );
} else {
	initPopupOverlay();
}

export default initPopupOverlay;
